export default __webpack_public_path__ + "static/media/okr-right.cc1ff4d0.png";